import { useQueryClient } from '@tanstack/react-query'
import { taskQueryKeys } from '@omnea-app/fe-tasks/queryKeys'
import { requestFormQueryKey } from '../../../../request-form/hooks/useGetRequestForm'
import { requestFormsQueryKey } from '../../submissions/useGetRequestForms'

export const useRefetchForms = () => {
  const queryClient = useQueryClient()
  const refetchForms = async ({ requestFormId, requestId }: { requestId: string; requestFormId: string }) => {
    await Promise.all([
      queryClient.refetchQueries({
        queryKey: [requestFormQueryKey, requestFormId],
      }),
      queryClient.refetchQueries({
        queryKey: [requestFormsQueryKey, requestId],
      }),
      queryClient.refetchQueries({
        queryKey: taskQueryKeys.mineForRequest(requestId),
      }),
    ])
  }

  return refetchForms
}
